import axios from "axios";

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/api_server"
    : "https://www.ppkm.org.my/api_server";

const getSecretariat = async () => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/get_secretariat/`);
    return data;
  } catch (error) {
    return error;
  }
};

const editSecretariat = async (data: any) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/edit_secretariat/`,
      data
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

const deactivateMembership = async (payload: any) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/deactivate_secretariat/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const reactivateMembership = async (payload: any) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/reactivate_secretariat/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const SecretariatController = {
  getSecretariat,
  editSecretariat,
  deactivateMembership,
  reactivateMembership,
};
export default SecretariatController;
